// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__33E6a","head":"Table_head__1xa3t","col":"Table_col__2tnZW"};